// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs } from "firebase/firestore";
// import { getMessaging } from 'firebase/messaging';


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//     apiKey: "AIzaSyAcAV_YFDIwUXA8HdkeNH4f_-bnyvKoxqo",
//     authDomain: "inddevelopment-1e8ac.firebaseapp.com",
//     projectId: "inddevelopment-1e8ac",
//     storageBucket: "inddevelopment-1e8ac.firebasestorage.app",
//     messagingSenderId: "627738177052",
//     appId: "1:627738177052:web:5c95aaa5bb348ca08739d9",
//     measurementId: "G-N89TZ59BJS"
// };

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDA-EsooPkWCIQ0foFo6seIAjI7nOjdQDs",
    authDomain: "indflutter.firebaseapp.com",
    projectId: "indflutter",
    storageBucket: "indflutter.firebasestorage.app",
    messagingSenderId: "890123278894",
    appId: "1:890123278894:web:408ed1d0b7c79ff101ddbf",
    measurementId: "G-EEP6L9JLNF"
};
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
// export default app;

